// Generic dark-header/zebra-row table — the same visual pattern already
// hand-rolled twice in SupplyChainDashboard.jsx (WeightTable/QtyTable),
// factored out once so drill-down lists and the ranking table don't each
// re-implement the same CSS-grid table shell.
export default function SimpleDataTable({ columns, rows, emptyMessage = 'No records match your filters.' }) {
  const gridTemplateColumns = columns.map((c) => c.width || '1fr').join(' ');
  return (
    <div style={{ minWidth: columns.length * 110 }}>
      <div style={{ display: 'grid', gridTemplateColumns, background: '#231C30', color: '#fff', borderRadius: '12px 12px 0 0' }}>
        {columns.map((c, i) => (
          <div key={c.key} style={{ padding: '11px 13px', fontSize: 10, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', textAlign: c.align || (i === 0 ? 'left' : 'right') }}>
            {c.label}
          </div>
        ))}
      </div>
      {rows.length === 0 && (
        <div style={{ padding: '46px 16px', textAlign: 'center', fontSize: 14, color: '#8C82A0' }}>{emptyMessage}</div>
      )}
      {rows.map((r, ri) => (
        <div key={r.key || ri} style={{ display: 'grid', gridTemplateColumns, background: ri % 2 ? '#FBFAFD' : '#fff', borderBottom: '1px solid #ECE7F2' }}>
          {columns.map((c, i) => (
            <div key={c.key} style={{ padding: '11px 13px', fontSize: 12.5, textAlign: c.align || (i === 0 ? 'left' : 'right'), fontVariantNumeric: 'tabular-nums', fontWeight: c.bold ? 700 : 400, color: c.color ? c.color(r) : '#231C30' }}>
              {c.render ? c.render(r) : r[c.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
